<template>
    <DFormRow
        :label="__('customers.contracts.prepaid')"
        :is-required="true"
        :error="errors.prepaid"
    >
        <DSwitch
            id="prepaid"
            :model-value="modelValue"
            @update:modelValue="emit('update:modelValue', $event)"
        />
    </DFormRow>
</template>

<script setup>
const emit = defineEmits('update:modelValue')

defineProps({
    modelValue: {
        type: [Boolean],
        default: false
    },
    errors: {
        type: Object,
        default: () => { return {} }
    }
})

</script>
